// extracted by mini-css-extract-plugin
module.exports = {"section":"_1oXi1Ikq-F5GEdRDCwQbDp","innerContent":"_3QjeXIOxImjx-U037sXsbD"};